import ComparisonPair from './ComparisonPair'
import { useTranslation } from 'react-i18next'
import { Product } from '../../stores/appReportsStore'
import { SelectedPair } from '../../services/sourcing/sourcingOptionsService'

interface Props {
  products: Product[];
  selectedPairs: SelectedPair[];
  hasOptions: boolean;
  loading: boolean;
  onQuantityChange: (id: string, v: string) => void;
  onEdit: (id: string) => void;
  onDeleteProduct?: (id: string) => void;
}

export default function SourcingComparison({ products, selectedPairs, hasOptions, loading, onQuantityChange, onEdit, onDeleteProduct }: Props) {
  const { t } = useTranslation()

  const pairs = products.map(p => ({
    left: p,
    right: selectedPairs.find(sp => sp.parentId === p.articleId)?.product
  }))

  return (
    <div className="max-w-7xl mx-auto grid grid-cols-1 gap-3 mb-10">
      <div className="flex flex-row hidden min-[1265px]:flex w-full">
        {/* left column */}
        <div className="flex gap-4 w-[45%]">
          <span className="ml-2 font-semibold text-base text-secondary dark:text-secondary-dark">
            {t('product.quantity')}
          </span>
          <span className="ml-4 font-semibold text-base text-secondary dark:text-secondary-dark">
            {t('product.currentProduct')}
          </span>
        </div>

        {/* right column - only show if any pair has a right product */}
        {pairs.some(pair => pair.right) && (
          <div className="flex gap-4 w-[55%] pr-36 min-[1265px]:pr-28">
            <span className="ml-4 min-[1265px]:ml-8 font-semibold text-base text-secondary dark:text-secondary-dark">
              {t('product.improvedProduct')}
            </span>
            <span className="ml-auto font-semibold text-base text-secondary dark:text-secondary-dark">
              {t('product.savings')}
            </span>
          </div>
        )}
      </div>

      {pairs.map((pair, index) => (
        <ComparisonPair key={pair.left.articleId || index} pair={pair} loading={loading} onQuantityChange={onQuantityChange} onEdit={onEdit} onDeleteProduct={onDeleteProduct}/>
      ))}
    </div>
  )
}
